import {
  Box,
  Button,
  Checkbox,
  Chip,
  CircularProgress,
  Divider,
  FormControlLabel,
  FormGroup,
  Paper,
  TextField,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import MenuItemMui from "@mui/material/MenuItem";
import { MenuItem } from "react-pro-sidebar";
import Header from "../../components/Header";
import axios from "axios";
import { useEffect, useMemo, useState } from "react";
import { tokens } from "../../theme";
import { Delete, Edit, RestartAlt, SaveAlt } from "@mui/icons-material";
import {
  MaterialReactTable,
  useMaterialReactTable,
} from "material-react-table";
import NotificationToaste from "../global/NotificationToaste";
import { DATA_SAVE_URL } from "../utils/UrlHandle";
import { USER_DEFAULT_VALUE } from "./UserRegistrationUtils";
import { getPayload, setPostPayload, setPutPayload } from "../../services/api";

const UserRegistration = () => {
  const [userGroup, setUserGroup] = useState([]);
  const [titles, setTitles] = useState([]);
  const [positions, setPositions] = useState([]);
  const [update, setUpdate] = useState(false);
  const [loading, setLoading] = useState(false);

  const [mainData, setMainData] = useState(USER_DEFAULT_VALUE);

  useEffect(() => {
    loadBasicData();
    return () => loadBasicData();
  }, []);

  const loadBasicData = async () => {
    setLoading(true);

    await getPayload
      .getPayloadData(DATA_SAVE_URL + "/api/v1/user/get/all")
      .then(function (response) {
        // console.log(response.data);
        setTitles(response.data.titles);
        setPositions(response.data.positions);
        setUserGroup(response.data.userGroups);
        setData(response.data.allUsers);
      })
      .catch(function (error) {
        console.log(error);
        setMessage(error);
        setMessageType("error");
        setOpen(true);
      });
    setLoading(false);
  };

  const handleCloseToaste = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }

    setOpen(false);
  };
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const [open, setOpen] = useState(false);
  const [message, setMessage] = useState();
  const [messageType, setMessageType] = useState();
  const isNonMobile = useMediaQuery("(min-width:600px)");
  const [data, setData] = useState([]);
  const handleSaveDBData = async () => {
    if (!update) {
      setLoading(true);
      const dataObj = {
        userGroup: {
          id: mainData.userGroup.userGroup,
        },
        titles: {
          id: mainData.title.title,
        },
        firstName: mainData.firstName.firstName,
        lastName: mainData.lastName.lastName,
        qualifications: mainData.qualifications,
        position: {
          id: mainData.position.position,
        },

        contactNo: mainData.contactNo,
        email: mainData.email.email,
        address1: mainData.address1,
        address2: mainData.address2,
        active: mainData.active,
        userName: mainData.userName.userName,
        password: mainData.password.password,
      };
      console.log(dataObj);

      await setPostPayload
        .setPayloadData(DATA_SAVE_URL + "/api/v1/user", dataObj)
        .then(function (response) {
          console.log(response);
          setMessage("Data saved successfully..!");
          setMessageType("success");
          setOpen(true);
          setData(response.data);
          resetMainData();
          setLoading(false);
        })
        .catch(function (error) {
          console.log(error);
          setMessage(error);
          setMessageType("error");
          setOpen(true);
          setLoading(false);
        });
    } else {
      setLoading(true);
      const dataObj = {
        userGroup: {
          id: mainData.userGroup.userGroup,
        },
        id: mainData.id,
        titles: {
          id: mainData.title.title,
        },
        firstName: mainData.firstName.firstName,
        lastName: mainData.lastName.lastName,
        qualifications: mainData.qualifications,
        position: {
          id: mainData.position.position,
        },

        contactNo: mainData.contactNo,
        email: mainData.email.email,
        address1: mainData.address1,
        address2: mainData.address2,
        active: mainData.active,
        userName: mainData.userName.userName,
        password: mainData.password.password,
        confirmPassword: mainData.confirmPassword.confirmPassword,
      };

      await setPutPayload
        .setPayloadData(DATA_SAVE_URL + "/api/v1/user/" + mainData.id, dataObj)
        .then(function (response) {
          console.log(response);
          setUpdate(false);
          setMessage("Data Updated successfully..!");
          setMessageType("success");
          setOpen(true);
          setData(response.data);
          resetMainData();
          setLoading(false);
        })
        .catch(function (error) {
          console.log(error);
          setMessage(error);
          setMessageType("error");
          setOpen(true);
          setLoading(false);
        });
    }
  };

  const resetMainData = () => {
    setUpdate(false);
    setMainData({
      userGroup: {
        userGroup: "",
        error: false,
      },
      title: {
        title: "",
        error: false,
      },
      firstName: {
        firstName: "",
        error: false,
      },
      lastName: {
        lastName: "",
        error: false,
      },
      qualifications: "",
      position: {
        position: "",
        error: false,
      },
      contactNo: "",
      email: {
        email: "",
        error: false,
      },
      address1: "",
      address2: "",
      active: true,
      userName: {
        userName: "",
        error: false,
      },
      password: {
        password: "",
        error: false,
      },
      confirmPassword: {
        confirmPassword: "",
        error: false,
      },
      id: "",
    });
  };

  const handleFormSubmit = () => {
    // console.log(mainData);
    if (
      mainData.userGroup.userGroup === "" ||
      mainData.title.title === "" ||
      mainData.firstName.firstName === "" ||
      mainData.lastName.lastName === "" ||
      mainData.position.position === "" ||
      mainData.email.email === "" ||
      mainData.userName.userName === "" ||
      mainData.password.password === "" ||
      mainData.confirmPassword.confirmPassword === ""
    ) {
      setMainData((pre) => ({
        ...pre,
        userGroup: {
          ...pre.userGroup,
          error: pre.userGroup.userGroup === "" ? true : false,
        },
        title: {
          ...pre.title,
          error: pre.title.title === "" ? true : false,
        },
        firstName: {
          ...pre.firstName,
          error: pre.firstName.firstName === "" ? true : false,
        },
        lastName: {
          ...pre.lastName,
          error: pre.lastName.lastName === "" ? true : false,
        },
        position: {
          ...pre.position,
          error: pre.position.position === "" ? true : false,
        },
        email: {
          ...pre.email,
          error: pre.email.email === "" ? true : false,
        },
        userName: {
          ...pre.userName,
          error: pre.userName.userName === "" ? true : false,
        },
        password: {
          ...pre.password,
          error: pre.password.password === "" ? true : false,
        },
        confirmPassword: {
          ...pre.confirmPassword,
          error: pre.confirmPassword.confirmPassword === "" ? true : false,
        },
      }));
    } else if (
      mainData.password.password !== mainData.confirmPassword.confirmPassword
    ) {
      setMainData((pre) => ({
        ...pre,
        password: {
          ...pre.password,
          error: true,
        },
        confirmPassword: {
          ...pre.confirmPassword,
          error: true,
        },
      }));
      setMessage("Password and confirm password does not match!");
      setMessageType("error");
      setOpen(true);
      return;
    } else {
      setMainData((pre) => ({
        ...pre,
        password: {
          ...pre.password,
          error: false,
        },
        confirmPassword: {
          ...pre.confirmPassword,
          error: false,
        },
      }));
      handleSaveDBData();
    }
  };

  const handleLoadEditDataUser = async (data) => {
    setLoading(true);

    await getPayload
      .getPayloadData(DATA_SAVE_URL + "/api/v1/user/" + data.id)
      .then(function (response) {
        console.log(response.data);
        setUpdate(true);
        setMainData((pre) => ({
          ...pre,
          id: response.data.id,
          userGroup: {
            ...pre.userGroup,
            userGroup: response.data.userGroup.id,
          },
          title: {
            ...pre.title,
            title: response.data.titles.id,
          },
          firstName: {
            ...pre.firstName,
            firstName: response.data.firstName,
          },
          lastName: {
            ...pre.lastName,
            lastName: response.data.lastName,
          },
          qualifications: response.data.qualifications,
          position: {
            ...pre.position,
            position: response.data.position.id,
          },
          contactNo: response.data.contactNo,
          address1: response.data.address1,
          address2: response.data.address2,
          email: {
            ...pre.email,
            email: response.data.email,
          },
          address1: response.data.address1,
          address2: response.data.address2,
          active: response.data.active,
          userName: {
            ...pre.userName,
            userName: response.data.userName,
          },
          password: {
            ...pre.password,
            password: response.data.password,
          },
          confirmPassword: {
            ...pre.confirmPassword,
            confirmPassword: response.data.password,
          },
        }));
        setLoading(false);
      })
      .catch(function (error) {
        console.log(error);
        setMessage(error);
        setMessageType("error");
        setOpen(true);
        setLoading(false);
      });
  };

  //should be memoized or stable
  const columns = useMemo(
    () => [
      {
        accessorKey: "firstName", //access nested data with dot notation
        header: "First Name",
        size: 80,
      },
      {
        accessorKey: "lastName",
        header: "Last Name",
        size: 80,
      },
      {
        accessorKey: "userName",
        header: "Username",
        size: 80,
      },
      {
        accessorKey: "contactNo",
        header: "Contact",
        size: 80,
      },

      {
        accessorKey: "email",
        header: "Email",
        size: 80,
      },
    ],
    []
  );

  const table = useMaterialReactTable({
    columns,
    data,
    enableRowActions: true,
    positionActionsColumn: "last",

    initialState: {
      density: "compact",
      pagination: { pageSize: 25, pageIndex: 0 },
    },

    muiPaginationProps: {
      rowsPerPageOptions: [25, 50, 100, 150, 200],
      showFirstButton: true,
      showLastButton: true,
    },

    muiTableBodyRowProps: ({ row }) => ({
      //conditionally style expanded rows
      sx: { padding: "10px" },
    }),

    renderRowActionMenuItems: ({ closeMenu, row }) => [
      <MenuItem
        // sx={{ padding: "10px" }}
        key={1}
        onClick={() => {
          handleLoadEditDataUser(row.original);
          closeMenu();
        }}
      >
        <Button variant="text" fullWidth startIcon={<Edit />}>
          <Typography variant="subtitle1">Edit</Typography>
        </Button>
      </MenuItem>,
      <MenuItem key={2}>
        <Button variant="text" fullWidth startIcon={<Delete />}>
          <Typography variant="subtitle1">Delete</Typography>
        </Button>
      </MenuItem>,
    ],
  });

  const handleReset = () => {
    setLoading(true);
    setUpdate(false);
    setMainData({
      userGroup: {
        userGroup: "",
        error: false,
      },
      title: {
        title: "",
        error: false,
      },
      firstName: {
        firstName: "",
        error: false,
      },
      lastName: {
        lastName: "",
        error: false,
      },
      qualifications: "",
      position: {
        position: "",
        error: false,
      },
      contactNo: "",
      email: {
        email: "",
        error: false,
      },
      address1: "",
      address2: "",
      active: true,
      userName: {
        userName: "",
        error: false,
      },
      password: {
        password: "",
        error: false,
      },
      confirmPassword: {
        confirmPassword: "",
        error: false,
      },
      id: "",
    });
    setLoading(false);
  };

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      {loading ? (
        <CircularProgress
          sx={{
            color: colors.greenAccent[500],
            position: "absolute",
            zIndex: 10,
          }}
        />
      ) : (
        ""
      )}
      <Paper
        sx={{ padding: "15px", borderRadius: "8px", width: "70%" }}
        elevation={3}
      >
        <Header
          title="User Registration"
          subtitle="Add / Update / De-Activate Users"
        />

        <Box
          display="grid"
          gap="8px"
          gridTemplateColumns="repeat(6, minmax(0, 1fr))"
          sx={{
            "& > div": {
              gridColumn: isNonMobile ? undefined : "span 6",
            },
          }}
        >
          {" "}
          <TextField
            select
            label="User Group"
            fullWidth
            size="small"
            defaultValue=""
            error={mainData.userGroup.error}
            sx={{ gridColumn: "span 1" }}
            value={mainData.userGroup.userGroup}
            onChange={(e) => {
              e.preventDefault();
              setMainData((pre) => ({
                ...pre,
                userGroup: {
                  ...pre.userGroup,
                  userGroup: e.target.value,
                },
              }));
            }}
          >
            {userGroup.map((data) => (
              <MenuItemMui key={data.id} value={data.id}>
                {data.groupName}
              </MenuItemMui>
            ))}
          </TextField>
          <TextField
            select
            label="Title"
            size="small"
            defaultValue=""
            error={mainData.title.error}
            sx={{ gridColumn: "span 1" }}
            value={mainData.title.title}
            onChange={(e) => {
              e.preventDefault();
              setMainData((pre) => ({
                ...pre,
                title: {
                  ...pre.title,
                  title: e.target.value,
                },
              }));
            }}
          >
            {titles.map((data) => (
              <MenuItemMui key={data.id} value={data.id}>
                {data.title}
              </MenuItemMui>
            ))}
          </TextField>
          <TextField
            fullWidth
            variant="outlined"
            error={mainData.firstName.error}
            type="text"
            label="First Name"
            size="small"
            name="ins_name"
            sx={{ gridColumn: "span 2" }}
            value={mainData.firstName.firstName}
            onChange={(e) => {
              e.preventDefault();
              setMainData((pre) => ({
                ...pre,
                firstName: {
                  ...pre.firstName,
                  firstName: e.target.value,
                },
              }));
            }}
          />
          <TextField
            fullWidth
            variant="outlined"
            size="small"
            type="text"
            label="Last Name"
            name="con_no"
            sx={{ gridColumn: "span 2" }}
            error={mainData.lastName.error}
            value={mainData.lastName.lastName}
            onChange={(e) => {
              e.preventDefault();
              setMainData((pre) => ({
                ...pre,
                lastName: {
                  ...pre.lastName,
                  lastName: e.target.value,
                },
              }));
            }}
          />
          <TextField
            fullWidth
            variant="outlined"
            size="small"
            type="text"
            label="Qualifications"
            name="con_no"
            sx={{ gridColumn: "span 6" }}
            value={mainData.qualifications}
            onChange={(e) => {
              e.preventDefault();
              setMainData((pre) => ({
                ...pre,
                qualifications: e.target.value,
              }));
            }}
          />
          <TextField
            select
            label="Position"
            fullWidth
            size="small"
            defaultValue=""
            error={mainData.position.error}
            sx={{ gridColumn: "span 2" }}
            value={mainData.position.position}
            onChange={(e) => {
              e.preventDefault();
              setMainData((pre) => ({
                ...pre,
                position: {
                  ...pre.position,
                  position: e.target.value,
                },
              }));
            }}
          >
            {positions.map((data) => (
              <MenuItemMui key={data.id} value={data.id}>
                {data.position}
              </MenuItemMui>
            ))}
          </TextField>
          <TextField
            fullWidth
            variant="outlined"
            size="small"
            type="text"
            label="Contact No"
            sx={{ gridColumn: "span 2" }}
            value={mainData.contactNo}
            onChange={(e) => {
              e.preventDefault();
              setMainData((pre) => ({
                ...pre,
                contactNo: e.target.value,
              }));
            }}
          />
          <TextField
            fullWidth
            variant="outlined"
            size="small"
            type="text"
            label="Email"
            sx={{ gridColumn: "span 2" }}
            error={mainData.email.error}
            value={mainData.email.email}
            onChange={(e) => {
              e.preventDefault();
              setMainData((pre) => ({
                ...pre,
                email: { ...pre.email, email: e.target.value },
              }));
            }}
          />
          <TextField
            fullWidth
            variant="outlined"
            size="small"
            type="text"
            label="Address 1"
            sx={{ gridColumn: "span 2" }}
            value={mainData.address1}
            onChange={(e) => {
              e.preventDefault();
              setMainData((pre) => ({
                ...pre,
                address1: e.target.value,
              }));
            }}
          />
          <TextField
            fullWidth
            variant="outlined"
            size="small"
            type="text"
            label="Address 2"
            sx={{ gridColumn: "span 2" }}
            value={mainData.address2}
            onChange={(e) => {
              e.preventDefault();
              setMainData((pre) => ({
                ...pre,
                address2: e.target.value,
              }));
            }}
          />
          <FormGroup sx={{ paddingLeft: "3px", gridColumn: "span 1" }}>
            <FormControlLabel
              control={
                <Checkbox
                  color="secondary"
                  name="active"
                  // value={mainData.active}
                  checked={mainData.active}
                  onChange={(e) =>
                    setMainData((pre) => ({ ...pre, active: e.target.checked }))
                  }
                  inputProps={{ "aria-label": "controlled" }}
                />
              }
              label="Active"
            />
          </FormGroup>
          <Divider sx={{ gridColumn: "span 6" }}>
            <Chip color="secondary" label="USER AUTHENTICATION" size="small" />
          </Divider>
          <TextField
            fullWidth
            variant="outlined"
            size="small"
            type="text"
            label="Username"
            name="address_line1"
            sx={{ gridColumn: "span 2" }}
            value={mainData.userName.userName}
            error={mainData.userName.error}
            onChange={(e) => {
              e.preventDefault();
              setMainData((pre) => ({
                ...pre,
                userName: { ...pre.userName, userName: e.target.value },
              }));
            }}
          />
          <TextField
            fullWidth
            variant="outlined"
            size="small"
            type="password"
            label="Password"
            name="address_line1"
            sx={{ gridColumn: "span 2" }}
            value={mainData.password.password}
            error={mainData.password.error}
            onChange={(e) => {
              e.preventDefault();
              setMainData((pre) => ({
                ...pre,
                password: { ...pre.password, password: e.target.value },
              }));
            }}
          />
          <TextField
            fullWidth
            variant="outlined"
            size="small"
            type="password"
            label="Confirm Password"
            name="address_line1"
            sx={{ gridColumn: "span 2" }}
            value={mainData.confirmPassword.confirmPassword}
            error={mainData.confirmPassword.error}
            onChange={(e) => {
              e.preventDefault();
              setMainData((pre) => ({
                ...pre,
                confirmPassword: {
                  ...pre.confirmPassword,
                  confirmPassword: e.target.value,
                },
              }));
            }}
          />
        </Box>

        <Divider sx={{ marginTop: "5px" }} />
        <Box
          sx={{ marginTop: "10px" }}
          display="flex"
          justifyContent="flex-end"
          marginBottom="1px"
          gap={1}
        >
          <Button
            type="button"
            disabled={loading}
            startIcon={<SaveAlt />}
            color="secondary"
            variant="contained"
            onClick={handleFormSubmit}
          >
            {update ? "Update Data" : "Save Data"}
          </Button>
          <Button
            type="button"
            disabled={loading}
            startIcon={<RestartAlt />}
            color="secondary"
            variant="contained"
            onClick={handleReset}
          >
            RESET
          </Button>
        </Box>
      </Paper>
      <Paper
        sx={{
          padding: "15px",
          borderRadius: "8px",
          width: "70%",
          marginTop: "15px",
        }}
        elevation={3}
      >
        <Header title="View All" subtitle="Update / Delete " />

        <MaterialReactTable table={table} />
      </Paper>
      <NotificationToaste
        handleCloseToaste={handleCloseToaste}
        open={open}
        message={message}
        messageType={messageType}
      />
    </Box>
  );
};

export default UserRegistration;
